import * as React from "react"
import { ArticleGW } from "./ArticleGW";
import { ArticleGroupGW } from "./ArticleGroupGW";
import { BDKalkCore } from "./BDKalkCore"; 
import { PADebug } from "./PADebug";

export interface NobblessGroup {
    id: number,
    groupId: string,
    description: string
}

export interface Supplier {
    id: number,
    description: string
}

///////////////   PriceBook  ////////////////

// PriceBook holds all the data and info about a price book
export class PriceBook {

    constructor() {
        this.m_loadComplete = false
        this.m_initStage = 1
        this.m_nobbLessGroups = new Array<ArticleGroupGW>()
        this.m_hasSorted = false
    }

    public SetDataLoadUrl(url: string) {
        this.m_dataLoadUrl = url
    }

    public GetDataLoadUrl() {
        return this.m_dataLoadUrl
    }

    public SetLogoUrl(url: string) {
        this.m_logotypeUrl = url
    }

    public GetLogoUrl() {
        return this.m_logotypeUrl
    }

    public SetPriceBookIndex(index: number) {
        this.m_priceBookIndex = index
    }

    public GetPriceBookIndex() {
        return this.m_priceBookIndex
    }

    public SetPriceBookId(id: number) {
        this.m_priceBookID = id
    }

    public GetPriceBookId() {
        return this.m_priceBookID
    }

    public SetTitle(title: string) {
        this.m_dropdownTitle = title
    }

    public GetTitle() {
        return this.m_dropdownTitle
    }

    public GetFileBase() {
        return "priceBook" + this.m_priceBookID.toString() 
    }

    public GetFullData() {
        return this.m_fullData
    }

    public GetAlphabeticalGroups(withFirstCharHierarchy: boolean) {
        if (withFirstCharHierarchy == true) {
            var hi = this.m_alphabeticalGroupsHierarchial

            if (hi) {
                return hi
            }
            else {
                this.GenerateAlphabeticalHierarchy()
                return this.m_alphabeticalGroupsHierarchial
            }
        }
        else {
            return this.m_alphabeticalGroups
        }
    }

    GenerateAlphabeticalHierarchy() {
        var ag = this.m_alphabeticalGroups
        var prevLetter = "£"
        var alphaGroup: ArticleGroupGW
        if (ag){
            this.m_alphabeticalGroupsHierarchial = new Array<ArticleGroupGW>()

            for (var i = 0; i < ag.length; i++) {
                if (ag[i].GetAlphaPos().length > 0) {
                    if (ag[i].GetAlphaPos().charAt(0) == prevLetter) {
                        this.m_alphabeticalGroupsHierarchial.push(ag[i])
                    }
                    else {
                        prevLetter = ag[i].GetAlphaPos().charAt(0)
                        alphaGroup = new ArticleGroupGW("99", "00", prevLetter.toUpperCase(), 1, prevLetter.toUpperCase())
                        this.m_alphabeticalGroupsHierarchial.push(alphaGroup)
                        this.m_alphabeticalGroupsHierarchial.push(ag[i])
                    }
                }
            }
        }
    }

    // Access : hierarchia groups
    public GetHierarchialGroups() {
        return this.m_hierarchialGroups
    }

    // Access : All articles
    public SetFullData(data: Array<ArticleGW>) {
        this.m_fullData = data
    }
    
    public SetAlphabeticalGroups(groups:Array<ArticleGroupGW>) {
        this.m_alphabeticalGroups = groups
    }

    public SetHierarchialGroups(groups: Array<ArticleGroupGW>) {
        this.m_hierarchialGroups = groups
    }

    public InitFullData() {
        this.m_fullData = new Array<ArticleGW>()
    }

    public InitHierarchialGroups() {
        this.m_hierarchialGroups = new Array<ArticleGroupGW>()
    }

    public InitAlphabeticalGroups() {
        this.m_alphabeticalGroups = new Array<ArticleGroupGW>()
    }

    public GetIsLoadCompleted() {
        return this.m_loadComplete
    }

    public FinishLoading() {
        this.m_loadComplete = true
    }

    public SetInitStage(newStage: number) {
        this.m_initStage = newStage
    }

    public GetInitStage() {
        return this.m_initStage
    }

    public GetNobbUnspecifiedArticles() {
        if (this.m_hasSorted == false) {
            if (this.GetNobbLessIsLoaded() == true) {
                this.m_hasSorted = true

                if (this.m_nobbUnspecifiedArticles) {
                    this.m_nobbUnspecifiedArticles.sort(function (a, b) {
                        var x = a.GetDescription();
                        var y = b.GetDescription();
                        if (x < y) { return -1; }
                        if (x > y) { return 1; }
                        return 0;
                    });
                }
            }
        }
        
        if (this.m_nobbUnspecifiedArticles) {
            return this.m_nobbUnspecifiedArticles
        }
        else {
            this.m_nobbUnspecifiedArticles = new Array < ArticleGW >()
            return this.m_nobbUnspecifiedArticles
        }
    }

    public AddNobbUnspecifiedArticles(articles: Array<ArticleGW>) {
        if (this.m_nobbUnspecifiedArticles) {
            for (var i = 0; i < articles.length; i++) {
                this.m_nobbUnspecifiedArticles.push(articles[i])
            }
        }
        else {
            this.m_nobbUnspecifiedArticles = articles
        }
    }
    
    GetNobbLessIsLoaded() {
        for (var g = 0; g < this.m_nobbLessGroups.length; g++) {
            if (this.m_nobbLessGroups[g].GetLoadedStatus().status != 2) {
                return false
            }
        }

        return true
    }

    public GetNobbUnspecifiedLoadPercentage() {
        var loaded = 0

        for (var i = 0; i < this.m_nobbLessGroups.length; i++) {
            if (this.m_nobbLessGroups[i].GetLoadedStatus().status == 2) {
                loaded++
            }
        }

        if (this.m_nobbLessGroups.length > 0) {
            return (loaded + 0.0000001) / this.m_nobbLessGroups.length
        }
        else {
            return 100.0000001
        }
    }

    public InitNobbLessGroups(nlg: Array<NobblessGroup>, core: BDKalkCore) {

        if (nlg) {
            for (var i = 0; i < nlg.length; i++) {
                var descr = core.GetNordic(nlg[i].description)
                if (descr == "") {
                    descr = nlg[i].groupId
                }

                if (descr == "") {
                    descr = "Gruppe:" + nlg[i].id
                }

                const newGroup = new ArticleGroupGW("withoutNobb_" + nlg[i].id.toString(), "withoutNobb_" + nlg[i].id.toString(), descr, 3, descr)
                
                this.m_nobbLessGroups.push(newGroup) 
            }

            this.m_nobbLessGroups.sort(function (a, b) {
                var x = a.GetDescription().toLowerCase();
                var y = b.GetDescription().toLowerCase();

                var newX : string = ""
                for (let i = 0; i < x.length; i++) {
                    if (x.charAt(i) == "æ") {
                        newX += "æ1"
                        continue
                    }

                    if (x.charAt(i) == "ø") {
                        newX += "æ2"
                        continue
                    }

                    if (x.charAt(i) == "å") {
                        newX += "æ3"
                        continue
                    }

                    newX += x.charAt(i)
                }

                var newY: string = ""
                for (let i = 0; i < y.length; i++) {
                    if (y.charAt(i) == "æ") {
                        newY += "æ1"
                        continue
                    }

                    if (y.charAt(i) == "ø") {
                        newY += "æ2"
                        continue
                    }

                    if (y.charAt(i) == "å") {
                        newY += "æ3"
                        continue
                    }

                    newY += y.charAt(i)
                }

                if (newX < newY) { return -1; }
                if (newX > newY) { return 1; }
                return 0;
            });

            // Preparing the groups to look right in a tree structure by removing the hierarchial 
            // connection towards L1 from undergroups at the end of the array
            var isLastBorn = true
            for (var i = this.m_nobbLessGroups.length - 1; i >= 0; i--) {
                if (this.m_nobbLessGroups[i].GetLevel() == 1) {
                    isLastBorn = true
                }
                else {
                    if (this.m_nobbLessGroups[i].GetLevel() == 2) {
                        this.m_nobbLessGroups[i].SetLastBorn(isLastBorn, 102)
                        isLastBorn = false
                    }
                    else {
                        this.m_nobbLessGroups[i].SetLastBorn(isLastBorn, 102)
                    }
                }
            }
        }
    }

    public InitSuppliers(sup: Array<Supplier>) {
        this.m_suppliers = sup
    }

    public GetNobbUnspecifiedGroups(withFirstCharHierarchy: boolean) {
        if (withFirstCharHierarchy == true) {
            var hi = this.m_nobbLessGroupsHierarchial

            if (hi) {
                return hi
            }
            else {
                if (this.m_initStage > 1) {
                    this.GenerateNobblessHierarchy()
                    return this.m_nobbLessGroupsHierarchial
                }
                else {
                    return this.m_nobbLessGroups
                }
            }
        }
        else {
            return this.m_nobbLessGroups
        }
    }

    GenerateNobblessHierarchy() {
        var nlg = this.m_nobbLessGroups
        var prevLetter = "£"
        var alphaGroup: ArticleGroupGW

        if (nlg) {
            this.m_nobbLessGroupsHierarchial = new Array<ArticleGroupGW>()

            for (var i = 0; i < nlg.length; i++) {
                if (nlg[i].GetAlphaPos().length > 0) {
                    if (nlg[i].GetAlphaPos().charAt(0) == prevLetter) {
                        this.m_nobbLessGroupsHierarchial.push(nlg[i])
                    }
                    else{
                        prevLetter = nlg[i].GetAlphaPos().charAt(0)
                        alphaGroup = new ArticleGroupGW("99", "00", prevLetter.toUpperCase(), 1, prevLetter.toUpperCase())
                        this.m_nobbLessGroupsHierarchial.push(alphaGroup)
                        this.m_nobbLessGroupsHierarchial.push(nlg[i])
                    }
                }
            }
        }
    }
    
    private m_logotypeUrl: string 
    private m_priceBookIndex: number
    private m_priceBookID: number
    private m_dropdownTitle: string
    private m_dataLoadUrl: string
    private m_initStage: number
    private m_nobbLessGroups: Array<ArticleGroupGW>
    private m_nobbLessGroupsHierarchial: Array<ArticleGroupGW>
    private m_suppliers: Array<Supplier>
    private m_fullData: Array<ArticleGW> // A complete array of all articles that has been downloaded and made available from the memory
    private m_alphabeticalGroups: Array<ArticleGroupGW> // An array which accesses the same data as m_fullData but through a set of dividing groups sorted alphabetically
    private m_alphabeticalGroupsHierarchial: Array<ArticleGroupGW>  // same as m_alphabeticalGroups but with added super groups which separates them by their first character
    private m_hierarchialGroups: Array<ArticleGroupGW> // An array which accesses the same data as m_fullData but through a set of dividing groups sorted as a nobb tree
    private m_nobbUnspecifiedArticles: Array<ArticleGW> // Array of articles which wasn't defined by any nobb group, which might occur within some custom made price books for instance
    private m_loadComplete: boolean // True once all groups have been loaded
    private m_hasSorted: boolean
}



// WEBPACK FOOTER //
// ./client/view/PriceBook.tsx